//for-formated
import { graphClient } from '../../graph-client'
import { useGlobalStore } from '../../../store/global-store'
import {
  CREATE_GAME_GOLD_MINER,
  GET_GAME_GOLD_MINER,
  GET_GAME_GOLD_MINER_COUNT,
  GET_GAME_GOLD_MINER_FIRST,
  GET_GAMES_GOLDS_MINERS,
  GET_GAMES_GOLDS_MINERS_GIFTS,
  GET_GAMES_GOLDS_MINERS_RANKING,
  GET_GOLD_MINER_HISTORY,
} from './gql'

export interface GoldMinerPrize {
  id: number
  giftId: number
  value: number
  giftName: string
  imgGift: string | null
  imgGiftFrame: string | null
}

export interface GoldMinerHistoryRow {
  giftIdEarning: number
  valueGift: number
  quantity: number
  createdAt: string
  giftName: string | null
  imgGift: string | null
}

export interface GoldMinerRankingRow {
  userId: number
  total: number
  userName: string
  imgUser: string | null
}

import type {
  Create,
  Get,
  GetCount,
  GetFirst,
  GetList,
} from './types'

class GameGoldMinerService {
  //queries
  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_GAME_GOLD_MINER,
      params,
    )

    return request?.getGameGoldMiner
  }

  async getCount(params: GetCount.Input) {
    const request = await graphClient.request<GetCount.Output>(
      GET_GAME_GOLD_MINER_COUNT,
      params,
    )

    return request?.gameGoldMinerCount
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_GAME_GOLD_MINER_FIRST,
      params,
    )

    return request?.getGameGoldMinerFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_GAMES_GOLDS_MINERS,
      { ...params, skip: take * skip },
    )

    return request?.getGamesGoldsMiners
  }

  // pool de prêmios possíveis do jogo (pra tela de reward)
  async getGifts(): Promise<GoldMinerPrize[]> {
    const request = await graphClient.request<{
      getGamesGoldsMinersGifts?: { data?: GoldMinerPrize[] }
    }>(GET_GAMES_GOLDS_MINERS_GIFTS)

    return request?.getGamesGoldsMinersGifts?.data ?? []
  }

  // ranking de ganhadores por período (createdAtInitial/Final)
  async getRanking(params: {
    createdAtInitial: string
    createdAtFinal?: string
    take?: number
  }): Promise<GoldMinerRankingRow[]> {
    const request = await graphClient.request<{
      getGamesGoldsMinersRanking?: { data?: GoldMinerRankingRow[] }
    }>(GET_GAMES_GOLDS_MINERS_RANKING, params)

    return request?.getGamesGoldsMinersRanking?.data ?? []
  }

  // "Meus ganhos" do jogador logado — página `page` de `take` linhas
  async getHistory(page: number, take = 40): Promise<GoldMinerHistoryRow[]> {
    const request = await graphClient.request<{
      getGamesGoldsMiners?: { data?: GoldMinerHistoryRow[] }
    }>(GET_GOLD_MINER_HISTORY, { take, skip: page * take, history: true })

    return request?.getGamesGoldsMiners?.data ?? []
  }

  //mutations
  async create(params: Create.Input) {
    // liveId (da URL, guardado no store): backend usa pra notificar o CHAT da
    // live no ganho médio (> 520). Só envia quando há live.
    const liveId = useGlobalStore.getState().liveId

    const request = await graphClient.request<Create.Output>(
      CREATE_GAME_GOLD_MINER,
      { ...params, ...(liveId ? { liveId } : {}) },
    )

    return request?.createGameGoldMiner
  }
}
export const gameGoldMinerService = new GameGoldMinerService()
